"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mpp = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const MppSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5c0 .137.112.25.25.25"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M21.147 6.5 17 2.353V6.25c0 .137.113.25.25.25z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M21.78 6.427 17.073 1.72a.76.76 0 0 0-.53-.22H6.75a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75h14.5a.75.75 0 0 0 .75-.75V6.957c0-.2-.078-.388-.22-.53M17 2.354 21.147 6.5H17.25a.25.25 0 0 1-.25-.25zM6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    stroke: "#C8C6C4",
    d: "M19.25 19.25h-10a.5.5 0 0 1-.5-.5v-9h10.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-.5.5Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#8BBF8A",
    fillRule: "evenodd",
    d: "M10.25 12h7.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25m0 2h7.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25m4 1h5.25v1h-5.25a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25M10 17.75a.25.25 0 0 0 .25.25h7.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#31752F",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "M9.442 10.481Q8.884 10 7.834 10H5.5v6h1.145v-2.121H7.76q.67 0 1.18-.253.507-.254.785-.71.275-.456.275-1.042 0-.911-.558-1.393M7.63 12.963h-.985v-2.034h1.022q1.127 0 1.127.992 0 .51-.294.776t-.87.266",
    clipRule: "evenodd"
  })]
});
const Mpp = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: MppSvg
}));
exports.Mpp = Mpp;